import React, { useEffect, useState, useRef, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { EyeIcon, ZapIcon, MusicIcon, FlaskConicalIcon, CodeIcon, CpuIcon } from 'lucide-react';
import { useExperiments } from '../lib/cmsStore';
import { ExperimentModal } from './ExperimentModal';
import { ExperimentItem } from '../lib/cmsTypes';
const iconMap: Record<string, any> = {
  EyeIcon,
  ZapIcon,
  MusicIcon,
  FlaskConicalIcon,
  CodeIcon,
  CpuIcon
};
interface ExperimentsSectionProps {
  initialSlug?: string;
}
export function ExperimentsSection({
  initialSlug
}: ExperimentsSectionProps) {
  const [selectedExperiment, setSelectedExperiment] = useState<ExperimentItem | null>(null);
  const {
    items,
    isLoading
  } = useExperiments();
  const hasOpenedRef = useRef(false);
  const publishedExperiments = items.filter(item => item.status === 'published').sort((a, b) => (a.order || 0) - (b.order || 0));
  // ISSUE 4: Auto-open modal for deep link
  useEffect(() => {
    if (initialSlug && !isLoading && items.length > 0 && !hasOpenedRef.current) {
      const found = items.find(e => e.slug === initialSlug || e.id === initialSlug);
      if (found) {
        setSelectedExperiment(found);
        hasOpenedRef.current = true;
      }
    }
  }, [initialSlug, isLoading, items]);
  if (isLoading) return null;
  if (publishedExperiments.length === 0) return null;
  return <>
      <section id="experiments" className="py-24 md:py-40 px-6 md:px-12 border-t border-border" data-id="element-166">
        <div className="max-w-6xl mx-auto" data-id="element-167">
          <span className="font-mono text-xs text-primary uppercase tracking-widest" data-id="element-168">
            // Experiments
          </span>
          <h2 className="font-display text-4xl md:text-6xl font-bold tracking-tighter mt-4" data-id="element-169">
            Lab
          </h2>

          <div className="mt-16 grid md:grid-cols-3 gap-4" data-id="element-170">
            {publishedExperiments.map((exp, i) => {
            const IconComponent = iconMap[exp.icon as string] || FlaskConicalIcon;
            return <motion.div key={exp.id || exp.title} initial={{
              opacity: 0,
              y: 40
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-50px'
            }} transition={{
              duration: 0.5,
              delay: i * 0.1
            }} onClick={() => setSelectedExperiment(exp)} className="group border border-border bg-card p-8 hover:-translate-y-1 cursor-pointer relative overflow-hidden transition-transform duration-300" data-id="element-171">
                  <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-172" />
                  <div className="relative z-10" data-id="element-173">
                    <IconComponent className="w-6 h-6 text-primary mb-6" data-id="element-174" />
                    <h3 className="font-display text-lg font-bold mb-2" data-id="element-175">
                      {exp.title}
                    </h3>
                    <p className="font-mono text-xs text-muted-foreground leading-relaxed" data-id="element-176">
                      {exp.shortDescription}
                    </p>
                  </div>
                </motion.div>;
          })}
          </div>
        </div>
      </section>

      <AnimatePresence data-id="element-177">
        {selectedExperiment && <ExperimentModal experiment={selectedExperiment} onClose={() => setSelectedExperiment(null)} data-id="element-178" />}
      </AnimatePresence>
    </>;
}